import axios from 'axios'
import { CommonWeekdayEnumResponse } from '@/api/services/common/weekdays/common-weekdays.dto'

class CommonWeekdaysService {
    async getWeekdays(): Promise<CommonWeekdayEnumResponse[]> {
        const response = await axios.get<CommonWeekdayEnumResponse[]>(`/common/weekDays/`)
        return response.data
    }
}

export const commonWeekdaysService = new CommonWeekdaysService()
